import { Link } from 'react-router-dom';
import { siteConfig, navLinks, contactInfo } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-secondary-800 text-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
              {siteConfig.name}
            </Link>
            <p className="mt-3 text-sm text-background-50/60 leading-relaxed">
              {siteConfig.description}
            </p>
            <p className="mt-2 text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              快速导航
            </h4>
            <div className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              热门标签
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/wanghong" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                网红黑料
              </Link>
              <Link to="/category/mingxing" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                明星秘闻
              </Link>
              <Link to="/category/shehui" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                社会热点
              </Link>
              <Link to="/category/zonghe" className="text-sm text-background-50/70 hover:text-background-50 transition-colors duration-200 whitespace-nowrap">
                综合吃瓜
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              关注我们
            </h4>
            <div className="flex gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-50/10 hover:bg-background-50/20 transition-colors duration-200 cursor-pointer" aria-label="RSS">
                <i className="ri-rss-line text-background-50"></i>
              </a>
            </div>
            <p className="mt-4 text-xs text-background-50/40">
              邮箱：{contactInfo.email}
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10 px-4 md:px-6 py-8">
        <div className="font-heading text-6xl md:text-8xl font-black text-background-50/8 text-center tracking-tighter select-none leading-none">
          五一吃瓜网
        </div>
      </div>
    </footer>
  );
}
